import { renderBlockCrossword } from "../Crossword";

const renderBlock = renderBlockCrossword;

export default renderBlock;
